// CONSTANTS are all caps.
const NS = 'RelatedArticles';
const CLS = 'relatedArticles';
const BLK = '.' + CLS + '-';

export class RelatedArticles {
	constructor($el) {
		// $el is the blk node return by the loadRelatedArticles function
		this.$el = $el;
		this.$cardList = this.$el.querySelectorAll('.articleCard');
		this.$btn = this.$el.querySelector('.btn-viewAll');
	}

	init() {
		this.initButton();
	}

	initButton() {
		if (! this.$btn) {
			return;
		}

		this.$btn.addEventListener('click', (e) => {
			this.viewAll(e);
		});
	}

	viewAll(e) {
		e.preventDefault();

		for (let i = this.$cardList.length - 1; i >= 0; i--) {
			this.$cardList[i].classList.add('d-block');
			this.$cardList[i].classList.remove('d-none');
			this.$cardList[i].classList.remove('d-lg-none');

			setTimeout(() => {
				this.$cardList[i].classList.add('show');
			}, 100);
		}

		this.$btn.classList.add('d-none');
	}
}
